import {default as React} from "react"
import {AnchorLink} from "gatsby-plugin-anchor-links"
import {
  connectStateResults,
  Highlight,
  Hits,
  Index,
  Snippet,
  PoweredBy,
} from "react-instantsearch-dom"

import {useMenuContext} from "../../state"


const HitCount = connectStateResults(({searchResults}) => {
  const hitCount = searchResults && searchResults.nbHits

  return hitCount > 0 ? (
    <div className="HitCount">
      {hitCount} résultat{hitCount !== 1 ? `s` : ``}
    </div>
  ) : <div className="HitCount" style={{justifyContent: 'center'}}>Aucun résultat</div>
})

const PageHit = ({hit}) => {
  const {closeMenu} = useMenuContext()

  return (
    <div onClick={closeMenu}>
      <AnchorLink to={hit.url} stripHash>
        <div>
          <Highlight attribute="title" hit={hit} tagName="mark"/>
        </div>
        <Snippet attribute="description" hit={hit} tagName="span"/>
      </AnchorLink>
    </div>
  )
}

const HitsInIndex = ({index, hideResults}) => (
  <Index indexName={index.name}>
    <HitCount/>
    <div onClick={hideResults}>
      <Hits className="Hits" hitComponent={PageHit}/>
    </div>
  </Index>
)


const SearchResult = ({indices, className, hideResults}) => {
  return (
    <div className={className}>
      {indices.map(index => (
        <HitsInIndex index={index} key={index.name} hideResults={hideResults}/>
      ))}
      <PoweredBy/>
    </div>
  )
}

export default SearchResult
